import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Routers from '../router/Routers';
import ScrollToTop from '../ScrollTop';
import Seo from '../SEO/Seo';
import Analytics from '../Analytics/Analytics';
import { isKnownRoute } from '../../utils/routes';

const Layout = () => {
  const location = useLocation();
  const isNotFoundPage = !isKnownRoute(location.pathname);

  return (
    <div>
      <Seo />
      <Analytics />
      <ScrollToTop />
      {!isNotFoundPage && <Header />}
      <Routers />
      {!isNotFoundPage && <Footer />}
    </div>
  );
};

export default Layout;
